import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const AccessibilityIcon = forwardRef<SVGSVGElement, Props>(
	(props, ref) => (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 16 16"
			xmlns="http://www.w3.org/2000/svg"
			ref={ref}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				fill="currentColor"
				d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14ZM9 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM4.55 6a.55.55 0 0 0-.108 1.088l1.952.39-.355 4.97a.515.515 0 0 0 1.024.11l.227-1.591c.067-.463.243-.967.71-.967.467 0 .643.504.71.967l.227 1.59a.515.515 0 0 0 1.024-.109l-.355-4.97 1.952-.39A.55.55 0 0 0 11.451 6H4.55Z"
			/>
		</svg>
	),
)
